import React, { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Actions from "../redux/actions";
import axios from "axios";
import { env } from "../config";
import Loader from "../components/Loader";
import Footer from "../components/Footer";
import { useNavigate } from "react-router";
const ProductdevelopmentIntro = React.lazy(
  () => import("../components/ProductdevelopmentIntro")
);
const ItConsultingHomePartnersSection = React.lazy(
  () => import("../components/ItConsultingHomePartnersSection")
);
const ItConsultingHomeCardsSection = React.lazy(
  () => import("../components/ItConsultingHomeCardsSection")
);
const ItConsultingHomeBusinessCardsSection = React.lazy(
  () => import("../components/ItConsultingHomeBusinessCardsSection")
);
const ContactUsSection = React.lazy(
  () => import("../components/ContactUsSection")
);

function ItConsultingHomePage() {
  const ItConsultingHomeData: any = useSelector(
    (state: any) => state?.Page?.ItConsultingHomePageContent
  );

  const navigate = useNavigate();

  const dispatch = useDispatch();

  let url = "/api/it-consulting-home-page-content?populate=deep";
  let action = Actions.ItConsultingHomepageAction;

  useEffect(() => {
    if (Object.keys(ItConsultingHomeData).length === 0) {
      setTimeout(() => {
        (async () => {
          await axios
            .get(`${env}${url}`)
            .then(function (response) {
              dispatch(action(response?.data?.data?.attributes));
            })
            .catch((error: any) => {
              console.log("error", error);
            });
        })();
      }, 0);
    }

    window.scrollTo({
      top: 0,
      left: 1,
      behavior: "smooth",
    });
  }, [dispatch]);

  const isLoading = Object.keys(ItConsultingHomeData).length === 0;

  return (
    <div>
      <Suspense fallback={<Loader />}>
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <ProductdevelopmentIntro
              imagePosition="mx-auto"
              ProductDevelopmentPageIntro={ItConsultingHomeData?.IntroContent}
              altText="IT
Consulting"
            />

            <ItConsultingHomePartnersSection
              IoTPartners={ItConsultingHomeData?.PartnersSection}
              altText="EMQX,Vitria"
            />
            <div className="px-5 py-7 lg:px-10 xl:px-20 lg:py-14 font-custom text-black-75   lg:mx-auto lg:max-w-screen-2xl flex flex-col items-center">
              <h4 className="text-2xl md:text-4xl lg:text-6xl  font-custom font-bold text-center">
                {ItConsultingHomeData?.ItConsultingDescription?.product}
              </h4>
              <p className="lg:text-lg md:text-base mt-5  font-normal text-center max-w-[80ch] ">
                {ItConsultingHomeData?.ItConsultingDescription?.description}
              </p>

              <button
                onClick={() =>
                  navigate(ItConsultingHomeData?.ItConsultingDescription?.link)
                }
                className=" bg-[#616161] text-white border mt-7 border-[#616161] hover:bg-white hover:text-[#616161] hover:border hover:border-[#616161] rounded-[50px] w-max px-4 py-2 my-3"
              >
                {ItConsultingHomeData?.ItConsultingDescription?.buttonText}
              </button>
            </div>

            <ItConsultingHomeCardsSection
              gridValues="grid lg:grid-cols-3 md:grid-cols-2  "
              CardsSection={ItConsultingHomeData?.CardsSection}
            />

            <ItConsultingHomeBusinessCardsSection
              Features={
                ItConsultingHomeData?.BusinessOppurtutinitiesSection
                  ?.CardsSection
              }
              title={
                ItConsultingHomeData?.BusinessOppurtutinitiesSection?.Title
              }
            />

            <ContactUsSection
              ContactUsSection={ItConsultingHomeData?.Contactus}
            />
            <Footer />
          </>
        )}
      </Suspense>
    </div>
  );
}

export default ItConsultingHomePage;
